'use client';

import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useLogging } from 'src/context/logging';
import { exists } from 'src/utils/exists/exists';
import { getProfileUrl } from 'src/utils/profileUrl';
import { Box, Typography } from 'src/components/PulseUI';
import InfoUnavailable from '../InfoUnavailable';

const ProfessionalMixList = ({ professionalMixes }) => {
  const { id, type } = useParams<{ id: string; type: string }>();
  const log = useLogging();

  return (
    <Box className="max-h-[500px] overflow-y-auto">
      {exists(professionalMixes) ? (
        [...professionalMixes]
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((mix, i) => {
            const filterId = mix.filter_id;

            return (
              <Box
                key={`${mix.title}-${i}`}
                className={`flex justify-between items-center py-1 ${
                  i === 0 ? '' : 'border-t border-gray-200'
                }`}
              >
                <Link
                  className="w-full"
                  href={`${getProfileUrl(type, id, 'affiliations')}?categories=${filterId}`}
                >
                  <Box
                    className="flex justify-between cursor-pointer py-1 pr-4 pl-1"
                    onClick={() => {
                      log.event('professionalMixCategoryClicked', {
                        category: mix.title,
                      });
                    }}
                  >
                    <Typography variant="body2">{mix.title}</Typography>
                    <Typography variant="body2">{mix.value}</Typography>
                  </Box>
                </Link>
              </Box>
            );
          })
      ) : (
        <InfoUnavailable />
      )}
    </Box>
  );
};

export default ProfessionalMixList;
